import "./publications.scss";

import PageTitleBreadcrumb from "@frontend/js/Components/Shared/PageTitleBreadcrumb/PageTitleBreadcrumb";
import PublicationsCards from "@frontend/js/Components/Site/PublicationsCards/PublicationsCards";
import LoadMoreButton from "@frontend/js/Components/Shared/LoadMoreButton/LoadMoreButton";
import CategoryFilter from "@frontend/js/Components/Shared/CategoryFilter/CategoryFilter";
import Pagination from "@frontend/js/Components/Shared/Pagination/Pagination";
import MetaHead from "@frontend/js/Components/Shared/MetaHead/MetaHead";
import { usePagination } from "@frontend/js/hooks/usePagination";
import SiteLayout from "@frontend/js/Layouts/SiteLayout";
import { usePage, router } from "@inertiajs/react";
import useT from "@frontend/js/hooks/useT";
import { buildLocalePath } from "@frontend/js/utils/locale";

export default function Publications({ page, collection, filters, meta }) {
    const { t } = useT("site");
    const pageProps = usePage().props;
    const { url } = usePage();
    const locale = pageProps.currentLocale;
    const siteLanguages = pageProps.siteLanguages || [];
    const pageTitle = page?.title?.[locale] || "";
    const urlParams = new URLSearchParams(url.split("?")[1] || "");
    const categoryParam = urlParams.get("category");
    const selectedFilterId = categoryParam ? parseInt(categoryParam) : null;

    const extractLocalePrefixFromHref = (hrefValue) => {
        const href = `${hrefValue || ""}`.trim();
        if (!href) return "";
        try {
            const baseOrigin =
                typeof window !== "undefined"
                    ? window.location.origin
                    : "http://localhost";
            const parsedUrl = new URL(href, baseOrigin);
            return parsedUrl.pathname.split("/").filter(Boolean)[0] || "";
        } catch {
            return "";
        }
    };

    const activeLanguage = siteLanguages.find((lang) => lang.locale === locale);
    const localePrefix = activeLanguage
        ? extractLocalePrefixFromHref(activeLanguage.href)
        : locale;

    const { filteredCards, localCollection, handleLoadMore, handlePageChange } =
        usePagination(collection, page.slug);

    const handlePageChangeWithCategory = (pageNumber) => {
        const params = categoryParam
            ? { category: categoryParam, page: pageNumber }
            : { page: pageNumber };
        router.get(buildLocalePath(localePrefix, page.slug), params, {
            preserveScroll: false,
            onSuccess: () => window.scrollTo({ top: 0, behavior: "smooth" }),
        });
    };

    return (
        <>
            <MetaHead meta={meta} />

            <SiteLayout>
                <div className="blogs page-shell">
                    <div className="blogs__container">
                        <PageTitleBreadcrumb
                            title={pageTitle}
                            variant="publications"
                        />
                        <CategoryFilter
                            filters={filters?.data}
                            selectedFilterId={selectedFilterId}
                            allLabel={t("all-articles-button")}
                            pageSlug={page.slug}
                            locale={localePrefix}
                            className="blogs__container__filter"
                        />

                        <PublicationsCards
                            cards={filteredCards}
                            locale={locale}
                        />
                    </div>
                    <LoadMoreButton
                        label={t("load-more-button-text")}
                        collection={localCollection}
                        locale={locale}
                        routeName="frontend.articles.filter"
                        onLoaded={handleLoadMore}
                        pageSlug={page.slug}
                        category={categoryParam}
                    />
                    <Pagination
                        collection={localCollection}
                        onPageChange={handlePageChangeWithCategory}
                    />
                </div>
            </SiteLayout>
        </>
    );
}
